/*eslint-env jquery*/
import React, { Component } from 'react';
import { Link ,withRouter} from 'react-router-dom';
import { connect  } from 'react-redux';
import { ready } from '../utils';

function toggle_slimscroll(item) {
  if ($('#wrapper').hasClass('enlarged')) {
    $(item).css('overflow', 'inherit').parent().css('overflow', 'inherit');
    $(item).siblings('.slimScrollBar').css('visibility', 'hidden');
  } else {
    $(item).css('overflow', 'hidden').parent().css('overflow', 'hidden');
    $(item).siblings('.slimScrollBar').css('visibility', 'visible');
  }
}

class Sidebar extends Component {
  componentDidMount() {
    ready(() => {


      var Sidemenu = function () {
        this.$body = $('body');
        this.$openLeftBtn = $('.open-left');
        this.$menuItem = $('#sidebar-menu a');
      };
      Sidemenu.prototype.openLeftBar = function () {
        $('#wrapper').toggleClass('enlarged');
        $('#wrapper').addClass('forced');

        if ($('#wrapper').hasClass('enlarged') && $('body').hasClass('fixed-left')) {
          $('body').removeClass('fixed-left').addClass('fixed-left-void');
        } else if (!$('#wrapper').hasClass('enlarged') && $('body').hasClass('fixed-left-void')) {
          $('body').removeClass('fixed-left-void').addClass('fixed-left');
        }

        if ($('#wrapper').hasClass('enlarged')) {
          $('.left ul').removeAttr('style');
        } else {
          $('.subdrop').siblings('ul:first').show();
        }

        toggle_slimscroll('.slimscrollleft');
        $('body').trigger('resize');
      };
      Sidemenu.prototype.menuItemClick = function (e) {
        if (!$('#wrapper').hasClass('enlarged')) {
          if ($(this).parent().hasClass('has_sub')) {
          }
          if (!$(this).hasClass('subdrop')) {
            // hide any open menus and remove all other classes
            $('ul', $(this).parents('ul:first')).slideUp(350);
            $('a', $(this).parents('ul:first')).removeClass('subdrop');
            $('#sidebar-menu .pull-right i').removeClass('md-remove').addClass('md-add');

            // open our new menu and add the open class
            $(this).next('ul').slideDown(350);
            $(this).addClass('subdrop');
            $('.pull-right i', $(this).parents('.has_sub:last')).removeClass('md-add').addClass('md-remove');
            $('.pull-right i', $(this).siblings('ul')).removeClass('md-remove').addClass('md-add');
          } else if ($(this).hasClass('subdrop')) {
            $(this).removeClass('subdrop');
            $(this).next('ul').slideUp(350);
            $('.pull-right i', $(this).parent()).removeClass('md-remove').addClass('md-add');
          }
        }

        // if /organization in url, add active class to organization menu item
    
        
      };
      Sidemenu.prototype.init = function () {
        let $this = this;
        let ua = navigator.userAgent,
          event = ua.match(/iP/i) ? 'touchstart' : 'click';
        this.$openLeftBtn.on(event, function (e) {
          e.stopPropagation();
          $this.openLeftBar();
        });
        $this.$menuItem.on(event, $this.menuItemClick);
        $('#sidebar-menu ul li.has_sub a.active')
          .parents('li:last')
          .children('a:first')
          .addClass('active')
          .trigger('click');
      };
      $.Sidemenu = new Sidemenu();
      $.Sidemenu.Constructor = Sidemenu;
      $.Sidemenu.init();
    });
  }
  render() {
    return (
      <div className='left side-menu'       
      >
        <div
          className='slimScrollDiv'
    
        >
          <div className='sidebar-inner slimscrollleft' >
            <div id='sidebar-menu'>
              <ul
         
              >
                <li className='menu-title user-name'>{this.props.user.name}</li>
                <li className='menu-title user-email'>{this.props.user.email}</li>

                {this.props.user.is_admin && (
                  <React.Fragment 
                 
                  >
                       <li>
                      <Link to='/main-page' className='waves-effect waves-primary'>
                        <i className='mdi mdi-home'></i>
                        <span> Dashboard </span>
                      </Link>
                    </li>
                    <li>
                  <Link to='/projects' className='waves-effect waves-primary'>
                    <i className='mdi mdi-folder'></i>
                    <span> Projects </span>
                  </Link>
                </li>
                <li>
                      <Link to='/organizations' className={`waves-effect waves-primary`}>
                        <i className='mdi mdi-inbox-arrow-down'></i>
                        <span> Organizations </span>
                      </Link>
                    </li>


                <li>
                  <Link to='/users' className='waves-effect waves-primary'>
                    <i className='mdi mdi-account'></i>
                    <span> User management </span>
                  </Link>
                </li>

                <li>
                  <Link to='/user-report' className='waves-effect waves-primary'>
                    <i className='mdi mdi-account'></i>
                    <span> User Report </span>
                  </Link>

                </li>

                <li>
                  <Link to='/reports' className='waves-effect waves-primary'>
                    <i className='mdi mdi-clipboard-text'></i>
                    <span>User Activity Log</span>
                  </Link>
                </li> 
                <li>
                  <Link to='/library' className='waves-effect waves-primary'>
                    <i className='mdi mdi-library'></i>
                    <span> Master Library </span>
                  </Link>
                </li>
                <li>
                      <Link to='/studycases' className='waves-effect waves-primary'>
                        <i className='mdi mdi-folder'></i>
                        <span> Case Studies </span>
                      </Link>
                    </li>
                <li>
                  <Link to='/resource-report' className='waves-effect waves-primary'>
                    <i className='mdi mdi-clipboard-text'></i>
                    <span>Master Library Report</span>
                  </Link>
                </li>

                    
                    
                   
                    <li>
                      <Link to='/glossary' className='waves-effect waves-primary'>
                        <i className='mdi mdi-file-word-box'></i>
                        <span> Glossary </span>
                      </Link>
                    </li>                     
                    <li>
                    <Link to='/dictionaries' className='waves-effect waves-primary'>
                      <i className='mdi mdi-pencil'></i>
                      <span> Text management </span>
                    </Link>
                  </li>
              
                  </React.Fragment>
                  
                )}

                {!this.props.user.is_admin && ( <React.Fragment>
                  <li>
                  <Link to='/projects' className='waves-effect waves-primary'>
                    <i className='mdi mdi-folder'></i>
                    <span> Projects </span>
                  </Link>
                </li>
                  <li>
                  <Link to='/users' className='waves-effect waves-primary'>
                    <i className='mdi mdi-account'></i>
                    <span> User management </span>
                  </Link>
                </li>
                <li>
                      <Link to='/studycases' className='waves-effect waves-primary'>
                        <i className='mdi mdi-folder'></i>
                        <span> Case Studies </span>
                      </Link>
                    </li>
                    <li>
                  <Link to='/resource-report' className='waves-effect waves-primary'>
                    <i className='mdi mdi-clipboard-text'></i>
                    <span>Master Library </span>
                  </Link>
                </li>

                </React.Fragment>
                 
                )}
               

            
              </ul>

              <div className='clearfix'></div>
            </div>
            <div className='clearfix'></div>
          </div>
          <div
            className='slimScrollBar'
            style={{
              backgroundColor: 'rgb(152, 166, 173)',
              width: '5px',
              position: 'absolute',
              top: '0px',
              opacity: 0.4,
              display: 'none',
              borderRadius: '7px',
              zIndex: 99,
              right: '1px',
              height: '430.149px',
              visibility: 'visible',
            }}
          ></div>
          <div
            className='slimScrollRail'
            style={{
              width: '5px',
              height: '100%',
              position: 'absolute',
              top: '0px',
              display: 'none',
              borderRadius: '7px',
              background: 'rgb(51, 51, 51)',
              opacity: 0.2,
              zIndex: 90,
              right: '1px',
            }}
          ></div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.authReducer.user,
});

export default withRouter(connect(mapStateToProps)(Sidebar));



// WEBPACK FOOTER //
// ./src/components/Sidebar.js